import routes from './routes';

// Import Messages
import generalMessages from '../containers/generalMessages';
import intl from '../intl';

const breadcrumbsConfig = {
  home:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
    ],
  login:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.LoginBc))}
    ],
  register:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.RegistrationBc))}
    ],
  success:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.RegisterPage, label: (intl.formatMessage(generalMessages.RegistrationBc))},
      {label: (intl.formatMessage(generalMessages.SuccessBc))}
    ],
  registerViaSMS:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: '/registracija/regular', label: (intl.formatMessage(generalMessages.RegistrationBc))},
      {label: (intl.formatMessage(generalMessages.PhoneVerification))}
    ],
  forgot_password:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.ForgotPasswordBc))}
    ],
  new_password:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.NewPasswordBc))}
    ],
  news:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.NewsBc))}
    ],
  news_details:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.NewsPage, label: (intl.formatMessage(generalMessages.NewsBc))},
    ],
  news_create:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.EventsPage, label: (intl.formatMessage(generalMessages.NewsBc))},
      {label: (intl.formatMessage(generalMessages.NewsCreateBc))}
    ],
  events:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.EventsBc))}
    ],
  events_details:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.EventsPage, label: (intl.formatMessage(generalMessages.EventsBc))},
    ],
  events_create:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.EventsPage, label: (intl.formatMessage(generalMessages.EventsBc))},
      {label: (intl.formatMessage(generalMessages.EventsCreateBc))}
    ],
  jobs:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.JobsBc))}
    ],
  jobs_details:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.Jobs, label: (intl.formatMessage(generalMessages.JobsBc))},
    ],
  job_create:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.PriceListAds))},
    ],
  faqs:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.AskedQuestions))}
    ],
  price_list:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.PriceListBc))}
    ],
  dashboard:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.DashboardBc))},
    ],
  company_info:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {to: routes.DashboardPage, label: (intl.formatMessage(generalMessages.DashboardBc))},
      {label: 'Informacije o kompaniji'}
    ],
  preselection:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.PreselectionType))}
    ],
  selection:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.SelectionType))}
    ],
  privacy_policy:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.PrivacyPolicy))}
    ],
  terms_of_use:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.TermsOfUse))}
    ],
  about_us:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.AboutUs))}
    ],
  jobs_to_mail:
    [
      {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
      {label: (intl.formatMessage(generalMessages.JobsToMail))}
    ],
  // employers:
  // [
  //   {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
  //   {to: routes.Employers, label: (intl.formatMessage(generalMessages.Employers))}
  // ],
  employer:
  [
    {to: routes.HomePage, label: (intl.formatMessage(generalMessages.HomeBc)), icon: `#home`},
    {label: (intl.formatMessage(generalMessages.Employer))}
  ],
};

export default breadcrumbsConfig;
